const getCity = () => {
  switch (window.location.host) {
    case 'sabara.soucidadao.appolus.com.br':
      return { label: 'Sabará', value: 'SABARA' }
    default:
      return { label: 'Apresentação', value: 'DESENVOLVIMENTO' }
  }
}

export default { getCity }
